export const personRoles = {
    BENEFICIARY: 'BENEFICIARY',
    ORGANISER: 'ORGANISER',
    PARTICIPANT: 'PARTICIPANT',
};
